import type { LucideIcon } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { MoneyValue } from './MoneyValue';
import { number } from '@/lib/format';
import { cn } from '@/lib/utils';

interface ShiftSummaryCardProps {
  label: string;
  icon: LucideIcon;
  count: number;
  gross: number;
  discount?: number;
  accent?: 'crimson' | 'gold' | 'neutral';
}

export function ShiftSummaryCard({
  label,
  icon: Icon,
  count,
  gross,
  discount,
  accent = 'neutral',
}: ShiftSummaryCardProps) {
  return (
    <Card className="overflow-hidden">
      <div
        className={cn(
          'flex items-center gap-2 px-5 py-3',
          accent === 'crimson' && 'bg-primary text-primary-foreground',
          accent === 'gold' && 'bg-gold-500 text-ink-900',
          accent === 'neutral' && 'bg-secondary text-ink-900',
        )}
      >
        <Icon className="h-5 w-5" />
        <span className="font-display font-semibold">{label}</span>
        <span className="tnum ml-auto rounded-full bg-black/10 px-2.5 py-0.5 text-xs font-bold">
          {number(count)} transaksi
        </span>
      </div>
      <div className="px-5 py-4">
        <p className="text-xs font-semibold uppercase tracking-wide text-ink-400">Bruto</p>
        <MoneyValue value={gross} emphasis className="text-2xl" />
        {typeof discount === 'number' && discount > 0 && (
          <p className="mt-1 text-xs text-success">
            Diskon <MoneyValue value={discount} className="text-xs text-success" />
          </p>
        )}
      </div>
    </Card>
  );
}
